export default __webpack_public_path__ + "static/media/Icone_agence.4b451b26.svg";